module.exports = __webpack_public_path__ + "img/1567785908.dc660718.jpg";